import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const defaultLabels = {
  modalTitle: 'Book Appointment',
  selectSubjectLabel: 'Select Pet',
  selectSubjectPlaceholder: 'Choose a pet...',
  noSubjectsMessage: "This client doesn't have any pets yet. Please add a pet first.",
  selectServiceLabel: 'Select Service',
  selectServicePlaceholder: 'Choose a service...',
  selectGroomerLabel: 'Select Groomer',
  selectGroomerOptional: '(Optional)',
  selectGroomerPlaceholder: 'Any available groomer',
  dateLabel: 'Date',
  timeLabel: 'Time',
  timePlaceholder: 'Choose a time slot...',
  loadingTimesMessage: 'Loading available times...',
  noTimesMessage: 'No available time slots for this date',
  addExtrasLabel: 'Add Popular Extras',
  specialRequestsLabel: 'Special Requests',
  specialRequestsPlaceholder: 'Any special instructions or requests...',
  submitButton: 'Book Appointment',
  submittingButton: 'Booking...',
};

const useBookingFormLabels = () => {
  const [labels, setLabels] = useState(defaultLabels);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLabels = async () => {
      try {
        const response = await axios.get(`${API_URL}/business-info/booking_form_labels`);
        if (response.data.info_value) {
          const savedLabels = JSON.parse(response.data.info_value);
          setLabels(prev => ({
            ...prev,
            ...savedLabels,
          }));
        }
      } catch (error) {
        console.error('Load booking form labels error:', error);
        // Keep defaults if not found
      } finally {
        setLoading(false);
      }
    };

    loadLabels();
  }, []);

  return { labels, loading };
};

export default useBookingFormLabels;
